var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('a',{staticClass:"Video custom",attrs:{"href":"//www.youtube.com/watch?v=VGAgvlnpNPQ","target":"_blank"}},[_c('img',{staticClass:"w-100",attrs:{"src":require("../assets/images/video-cover_en.jpg"),"alt":""}})])}]

export { render, staticRenderFns }